import actions from "./actions";

export default {
  namespaced: true,
  state: {
    auCapitals: [],
    auCapital: {},
    auMyProjectsOrders: null,
    portfolioTracker: [],
    searchedAuCapitals: [],
    investors: [],
    investorsTotal: null,
    portfolioTotal: null,
    dataLoading: false,
    followings: [],
    updateInfoFlag: 0,
    investments: []
  },
  getters: {
    investments: state => {
      return state.investments;
    },

    auCapitals: state => {
      return state.auCapitals;
    },

    myProjectsOrders: state => {
      return state.auMyProjectsOrders;
    },

    auCapital: state => {
      return state.auCapital;
    },

    portfolioTracker: state => {
      return state.portfolioTracker;
    },

    searchedAuCapitals: state => {
      return state.searchedAuCapitals;
    },

    investors: state => {
      return state.investors;
    },

    investorsTotal: state => {
      return state.investorsTotal;
    },

    portfolioTotal: state => {
      return state.portfolioTotal;
    },

    dataLoading: state => {
      return state.dataLoading;
    },

    followings: state => {
      return state.followings;
    },

    updateInfoFlag: state => {
      return state.updateInfoFlag;
    }
  },
  mutations: {
    setInvestments(state, investments) {
      state.investments = investments;
    },

    setAuCapitals(state, capitals) {
      state.auCapitals = capitals;
    },

    setAuCapital(state, capital) {
      state.auCapital = capital;
    },

    setMyProjectsOrders(state, orders) {
      state.auMyProjectsOrders = orders;
    },

    setPortfolioTracker(state, pTracker) {
      state.portfolioTracker = pTracker;
    },

    setSearchedAuCapitals(state, capitals) {
      state.searchedAuCapitals = capitals;
    },

    setInvestors(state, investors) {
      state.investors = investors;
    },

    setInvestorsTotal(state, investorsTotal) {
      state.investorsTotal = investorsTotal;
    },

    setPortfolioTotal(state, portfolioTotal) {
      state.portfolioTotal = portfolioTotal;
    },

    setDataLoading(state, dataLoading) {
      state.dataLoading = dataLoading;
    },

    setFollowings(state, followings) {
      state.followings = followings;
    },

    setUpdateInfoFlag(state, updateInfoFlag) {
      state.updateInfoFlag = updateInfoFlag;
    }
  },
  actions
};